import React from 'react';
import { Link } from 'react-router-dom';

function BlogCard({ slug, title, image, excerpt, author }) {
  return (
    <div className="col-12 col-md-6 col-lg-4">
      <div className="card h-100 border-0">
        <img src={image} className="card-img-top rounded-0" alt={title} />
        <div className="card-body px-0">
          <h4 className="card-title fw-bold mb-3">{title}</h4>
          <p className="card-text text-muted mb-4">{excerpt}</p>
          <div className="meta-info d-flex flex-wrap mb-4">
            <span className="me-3">
              <i className="bi bi-person"></i> By <a href="#">{author}</a>
            </span>
          </div>
          <Link
            to={`/blog/${slug}`}
            className="btn btn-outline-secondary custom-btn text-uppercase"
          >
            Read More
          </Link>
        </div>
      </div>
    </div>
  );
}

export default BlogCard;
